import style from "./SubscribeToPremium.module.css";

import Logo from "@/ui/logo/Logo";
import Icon from "@/ui/icon/Icon";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Keys, not text: this runs at import time, so a string here would stay in the
// language the app loaded in. The component renders t(...) of each.
const PREMIUM_CARD = {
	titleKey: "payments:premiumCard.subscribe.title",
	infoKey: "payments:premiumCard.subscribe.info",
	actionKey: "auth:profile.certificates.locked.action",
	to: "/plans",
	hoverIcon: "fa-shopping-basket",
};

const REGISTER_CARD = {
	titleKey: "payments:premiumCard.register.title",
	infoKey: "payments:premiumCard.register.info",
	actionKey: "common:nav.register",
	to: "/register",
	hoverIcon: "fa-user-plus",
};

/**
 * `register` swaps the premium upsell for a sign up nudge: a free course is
 * already unlocked for anyone with an account, so a logged out visitor needs
 * to register, not to subscribe.
 */
function SubscribeToPremium({ register = false }) {
	const { t } = useTranslation();
	const card = register ? REGISTER_CARD : PREMIUM_CARD;

	return (
		<div className={style.card}>
			<div className={style.header}>
				<div className={style.logo}>
					<Logo mini={true} />
				</div>
			</div>

			<div className={style.body}>
				<div className={style.title}>{t(card.titleKey)}</div>

				<div className={style.info}>{t(card.infoKey)}</div>

				<Link to={card.to} className={style.button}>
					<span>{t(card.actionKey)}</span>
					<div className={style.icoHolder}>
						<span className={style.defaultIcon}>
							<Icon icon="fa-arrow-right-long" />
						</span>
						<span className={style.hoverIcon}>
							<Icon icon={card.hoverIcon} />
						</span>
					</div>
				</Link>
			</div>
		</div>
	);
}

export default SubscribeToPremium;
